import React, { createContext, useContext, useState, useCallback } from 'react';

interface ProjectTreeState {
  expandedProjectId: string | null;
  setExpandedProjectId: (id: string | null) => void;
  toggleProject: (id: string) => void;
  projectsExpanded: boolean;
  setProjectsExpanded: (expanded: boolean) => void;
}

const ProjectTreeContext = createContext<ProjectTreeState | null>(null);

export const ProjectTreeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [expandedProjectId, setExpandedProjectId] = useState<string | null>(null);
  const [projectsExpanded, setProjectsExpanded] = useState(false);

  const toggleProject = useCallback((id: string) => {
    setExpandedProjectId(prev => prev === id ? null : id);
  }, []);

  return (
    <ProjectTreeContext.Provider value={{
      expandedProjectId,
      setExpandedProjectId,
      toggleProject,
      projectsExpanded,
      setProjectsExpanded,
    }}>
      {children}
    </ProjectTreeContext.Provider>
  );
};

export const useProjectTree = () => {
  const ctx = useContext(ProjectTreeContext);
  if (!ctx) throw new Error('useProjectTree must be used within ProjectTreeProvider');
  return ctx;
};
